import styled from "styled-components";
import { Link } from "react-router-dom";
// Constants
import { errorColor } from "../config/constants";

const NavigationLink = styled(Link)`
  padding: 0 15px;
  height: 38px;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${errorColor};
  border-radius: 5px;
  background: transparent;
  cursor: pointer;
`;
const NavigationBtn = styled.button`
  padding: 0 15px;
  height: 38px;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${errorColor};
  border-radius: 5px;
  background: transparent;
  cursor: pointer;
  @media (max-width: 570px) {
    margin: 0 0 0 10px;
    padding: 0 10px;
  }
`;
const NavImg = styled.img`
  margin-right: 10px;
  width: 20px;
  height: 20px;
  @media (max-width: 570px) {
    margin: 0;
  }
`;
const NavName = styled.p`
  font-size: 14px;
  font-weight: bold;
  color: ${errorColor};
  @media (max-width: 570px) {
    display: none;
  }
`;

const ButtonWithIcon = ({ icon, name, path, onClick }) => {
  return path ? (
    <NavigationLink to={path}>
      <NavImg src={icon} alt="ico-link" />
      <NavName>{name}</NavName>
    </NavigationLink>
  ) : (
    <NavigationBtn onClick={onClick}>
      <NavImg src={icon} alt="ico-link" />
      <NavName>{name}</NavName>
    </NavigationBtn>
  );
};

export default ButtonWithIcon;
